import { http } from './api.service';

export const StatusTypesService = {
  getStatusTypes(params) {
    return http.get('/status-types', {
      params,
    });
  },
};
